import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, Request, RequestOptions, URLSearchParams, RequestMethod } from '@angular/http';
import { Router } from '@angular/router';
import { Observable, ReplaySubject, Subject, throwError, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators'

import { UserInfoService, LoginInfoInStorage } from '../http/user-info.service'
import { SecureStorageService } from '../utilities/secure-storage.service'
import { AppSettings } from '../../configs/app-settings.config'
import { AppMetadataHandler } from '../../configs/app-metadata.handler'
import { AppConfig } from '../../configs/app.config';
import { environment } from '../../../../environments/environment'
import * as moment from 'moment';
import { Md5 } from 'ts-md5/dist/md5';

/* NG Zorro Messaging Service used: Change for production */
import { NzMessageService } from 'ng-zorro-antd/message';
import { ElementSchemaRegistry } from '@angular/compiler';
import { GlobalErrorHandler } from '../services/global-error-handler/global-error-handler.service';

@Injectable()

export class ApiRequestService {

    private headers: Headers;
    private requestOptions: RequestOptions;
    private modal_id = "global-dialog";
    public downloadQuotationAPI = "quotationContainer/downloadQuotationPdf"
    public token: string;
    public httpHeader: Headers;
    public options: RequestOptions;
    public lastAPICallTime: any;


    constructor(
        private appConfig: AppConfig,
        private http: Http,
        private router: Router,
        private userInfoService: UserInfoService,
        private appSettings: AppSettings,
        public msg: NzMessageService,
        public appMetadataHandler: AppMetadataHandler,
        private globalErrorHandler: GlobalErrorHandler,
        private secureStorageService: SecureStorageService
    ) {
        this.httpHeader = new Headers({ headers: { 'Content-type': 'application/json' } });
    }

    /**
     * This is a Global place to add all the request headers for every REST calls
     */
    appendAuthHeader(): Headers {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        // let token = this.userInfoService.getStoredToken();
        // if (token !==null) {
        //     headers.append("Authorization", token);
        // }
        return headers;
    }

    /**
     * This is a place to add all the request headers for every REST calls with Multipart Format
     */
    appendFormHeaderForMultipart(hash?: any): Headers {

        let headers = new Headers();
        headers.append("applicationId", environment.applicationId);
        headers.append("hash", "123");
        let token = this.token;
        if (token !== null) {
            headers.append("Authorization", token);
        }
        return headers;
    }

    appendFormHeader(hash?: any): Headers {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append("applicationId", environment.applicationId);
        headers.append("source", environment.applicationSource);
        if (hash != null) {
            headers.append("hash", hash);
        }
        let token = this.token;
        if (token !== null) {
            headers.append("Authorization", token);
        }
        return headers;
    }

    StoreTheUrlCall(url) {
        let urlSLS = this.secureStorageService.get('URLSLS');
        let parsedURLSLS
        try {
            parsedURLSLS = JSON.parse(urlSLS);
        }
        catch{
            parsedURLSLS = null
        }

        if (!urlSLS) {
            let URLDO = {};
            URLDO[url] = 1;
            this.secureStorageService.set('URLSLS', JSON.stringify(URLDO));
        }
        else {
            if (parsedURLSLS && parsedURLSLS[url]) {
                let count = parsedURLSLS[url];
                count = count + 1;
                parsedURLSLS[url] = count;
            }
            else if(parsedURLSLS){
                parsedURLSLS[url] = 1;
            }
            else{
                parsedURLSLS = {}
                parsedURLSLS[url] = 1;
            }
        }
        this.secureStorageService.set('URLSLS', JSON.stringify(parsedURLSLS));
        console.log("URL Calls", parsedURLSLS)
    }

    /**
     * This is a Global place to define all the Request Headers that must be sent for every ajax call
     */
    getRequestOptions(requestMethod, url: string, urlParam?: URLSearchParams, body?: Object, exception?: any, withoutServerContext?): RequestOptions {
        let currentTimeStamp = moment();
        let idleTime = currentTimeStamp.diff(this.lastAPICallTime, "minutes");
        if (exception || idleTime < this.appSettings.sessionTimeoutInMinutes) {
            var header = null;
            if (body != null || body != undefined) {
                var hash = Md5.hashStr(JSON.stringify(body).replace(/\r?\n|\r/g, "").replace(/\s+/g, ""));
                header = this.appendFormHeader(hash);
            } else {
                header = this.appendFormHeader(null);
            }

            let baseApiPath = withoutServerContext? this.appConfig.baseApiPathWithoutContext : this.appConfig.baseApiPath
            // if (!this.appMetadataHandler.featureFlags.enableAPIMapper)
                url = baseApiPath + url
            // else
            //     url = baseApiPath + this.APIEndpointMap[url]
            let options = new RequestOptions({
                headers: header,
                method: requestMethod,
                url: url,
                body: body
            });
            if (urlParam) {
                options = options.merge({ params: urlParam });
            }
            this.StoreTheUrlCall(url)
            return options;
        }
        else
            return null
    }
    // getRequestOptions(requestMethod, url: string, urlParam?: URLSearchParams, body?: Object, exception?: any, withoutServerContext?): RequestOptions {
    //     let currentTimeStamp = moment();
    //     let idleTime = currentTimeStamp.diff(this.lastAPICallTime, "minutes");
    //     if (exception || idleTime < this.appSettings.sessionTimeoutInMinutes) {
    //         var header = null;
    //         if (body != null || body != undefined) {
    //             var hash = Md5.hashStr(JSON.stringify(body).replace(/\r?\n|\r/g, "").replace(/\s+/g, ""));
    //             header = this.appendFormHeader(hash);
    //         } else {
    //             header = this.appendFormHeader(null);
    //         }

    //         let baseApiPath = withoutServerContext? this.appConfig.baseApiPathWithoutContext : this.appConfig.baseApiPath

    //         // let baseApiPath = (
    //         //     withoutServerContext ?
    //         //     // append secondaryTokenServerContext for post requests (for SSO related APIs)
    //         //     this.appConfig.baseApiPathWithoutContext + (requestMethod === 1 ? environment.secondaryTokenServerContext : '') :
    //         //     this.appConfig.baseApiPath
    //         // );

    //         // if (!this.appMetadataHandler.featureFlags.enableAPIMapper)
    //             url = baseApiPath + url
    //         // else
    //         //     url = baseApiPath + this.APIEndpointMap[url]


    //         let options = new RequestOptions({
    //             headers: header,
    //             method: requestMethod,
    //             url: url,
    //             body: body
    //         });
    //         if (urlParam) {
    //             options = options.merge({ params: urlParam });
    //         }
    //         this.StoreTheUrlCall(url)
    //         return options;
    //     }
    //     else
    //         return null
    // }

    getRequestOptionsForMultipart(requestMethod, url: string, urlParam?: URLSearchParams, body?: Object): RequestOptions {
        var header = null;
        header = this.appendFormHeaderForMultipart(null);


        if (!environment.production) {
            url = url
        } else {
            if (!this.appMetadataHandler.featureFlags.enableAPIMapper)
                url = this.appConfig.baseApiPath + url
            else
                url = this.appConfig.baseApiPath + this.APIEndpointMap[url]
        }
        let options = new RequestOptions({
            headers: header,
            method: requestMethod,
            url: url,
            body: body

        });
        if (urlParam) {
            options = options.merge({ params: urlParam });
        }

        return options;
    }

    get(url: string, urlParams?: URLSearchParams, withoutServerContext?, status?: boolean): Observable<any> {
        let me = this;
        let requestOptions = this.getRequestOptions(RequestMethod.Get, url, urlParams, undefined, false, withoutServerContext);
        if (requestOptions != null) {
            return this.http.request(new Request(requestOptions))
                .pipe(map((resp: any) => {
                    this.lastAPICallTime = moment()
                    if (typeof resp._body == 'string' && resp._body.includes('<html')) {
                        this.leaveApplication();
                    }
                    if (resp)
                        return this.globalErrorHandler.sanitizeJSONResp(resp)
                    else
                        return resp
                })
                    , catchError(function (error: any) {
                        console.log("http error:", error);
                        if (error.status === 401 || error.status === 403) {
                            me.router.navigate(['/logout']);
                        }

                        if (me.appMetadataHandler.featureFlags.redirectOnServerErrors) {
                            me.globalErrorHandler.redirectOnServerError(error.status)
                        }

                        //return throwError(error || 'Server error');
                        return of(me.globalErrorHandler.logFailedAPI(error, url))
                    }));
        }
        else {
            this.logout();
            this.leaveApplication();
            var subject = new Subject()
            subject.complete();
            return subject;
        }
    }

    APIerrorMap={}

    getCallWithAPIMapper(url: string, urlParams?: URLSearchParams, withoutServerContext?, pathVariables?, allowSensitiveHTML?): Observable<any> {
        let me = this;
        let revisedURL = this.mapperUtil('get', url, pathVariables)
        let requestOptions = this.getRequestOptions(RequestMethod.Get, revisedURL, urlParams, undefined, false, withoutServerContext);
        if (requestOptions != null) {
            return this.http.request(new Request(requestOptions))
                .pipe(map((resp: any) => {
                    this.lastAPICallTime = moment()
                    if (typeof resp._body == 'string' && resp._body.includes('<html') && !allowSensitiveHTML) {
                        this.leaveApplication();
                    }
                    if (resp)
                        return this.globalErrorHandler.sanitizeJSONResp(resp)
                    else
                        return resp
                })
                    , catchError(function (error: any) {
                        console.log("http error:", error);
                        // if(environment['showAPIConfigError'])
                        // alert("getCallWithAPIMapper URL not working  "+ url)
                        // console.log(url);
                        
                        // // this.APIerrorMap[url] = {
                        // //     revisedURL,error
                        // // }
                        // localStorage.set("APIerrorMap", this.APIerrorMap)
                        if (error.status === 401 || error.status === 403 || error.status === 504) {
                            // me.logout(error.status)
                        }

                        if (me.appMetadataHandler.featureFlags.redirectOnServerErrors) {
                            me.globalErrorHandler.redirectOnServerError(error.status)
                        }

                        //return throwError(error || 'Server error');
                        return of(me.globalErrorHandler.logFailedAPI(error, url))
                    }));
        }
        else {
            this.logout();
            this.leaveApplication();
            var subject = new Subject()
            subject.complete();
            return subject;
        }
    }

    // getCallWithAPIMapper(url: string, urlParams?: URLSearchParams, withoutServerContext?, pathVariables?): Observable<any> {
    //     let me = this;
    //     let revisedURL = this.mapperUtil('get', url, pathVariables)
    //     let requestOptions = this.getRequestOptions(RequestMethod.Get, revisedURL, urlParams, undefined, false, true);
    //     if (requestOptions != null) {
    //         // Add code here for undefined API calls
    //         if (revisedURL && !revisedURL.includes('undefined')) {
    //             return this.http.request(new Request(requestOptions))
    //                 .pipe(map((resp: any) => {
    //                     this.lastAPICallTime = moment()
    //                     if (typeof resp._body == 'string' && resp._body.includes('<html')) {
    //                         this.leaveApplication();
    //                     }
    //                     if (resp)
    //                         return this.globalErrorHandler.sanitizeJSONResp(resp)
    //                     else
    //                         return resp
    //                 })
    //                     , catchError(function (error: any) {
    //                         console.log("http error:", error);

    //                         // this.APIerrorMap[url] = {
    //                         //     revisedURL,error
    //                         // }
    //                         // localStorage.set("APIerrorMap", this.APIerrorMap)
    //                         if (error.status === 401 || error.status === 403) {
    //                             me.router.navigate(['/logout']);
    //                         }

    //                         if (me.appMetadataHandler.featureFlags.redirectOnServerErrors) {
    //                             me.globalErrorHandler.redirectOnServerError(error.status)
    //                         }

    //                         //return throwError(error || 'Server error');
    //                         return of(me.globalErrorHandler.logFailedAPI(error, url))
    //                     }));
    //         } else {
    //             localStorage.setItem(`undefinedServiceCd ${Math.random()}`, revisedURL)
    //             var subject = new Subject()
    //             subject.complete();
    //             return subject;
    //         }
    //     }
    //     else {
    //         this.logout();
    //         this.leaveApplication();
    //         var subject = new Subject()
    //         subject.complete();
    //         return subject;
    //     }
    // }
    post(url: string, body: Object): Observable<any> {
        let me = this;
        let requestOptions = this.getRequestOptions(RequestMethod.Post, url, undefined, body, false);
        if (requestOptions != null) {
            return this.http.request(new Request(requestOptions))
                .pipe(map((resp: any) => {
                    this.lastAPICallTime = moment()

                    if (typeof resp._body == 'string' && resp._body.includes('<html')) {
                        this.leaveApplication();
                    }
                    if (url == '/login') {
                        this.token = resp.headers.get('authorization');
                    }
                    if (resp)
                        return this.globalErrorHandler.sanitizeJSONResp(resp)
                    else
                        return resp
                })
                    , catchError(function (error: any) {
                        if (error.status === 401) {
                            me.router.navigate(['/logout']);
                        }
                        else if (error.status === 500) {
                            var jsonBody = error._body;
                        }

                        if (me.appMetadataHandler.featureFlags.redirectOnServerErrors) {
                            me.globalErrorHandler.redirectOnServerError(error.status)
                        }
                        //return throwError(error || 'Server error');
                        return of(me.globalErrorHandler.logFailedAPI(error, url))
                    }));
        }
        else {
            this.logout();
            this.leaveApplication();
            var subject = new Subject()
            subject.complete();
            return subject;
        }
    }

    postCallWithAPIMapper(url: string, body: Object): Observable<any> {
        let me = this;
        let revisedURL = this.mapperUtil('post', url)
        let requestOptions = this.getRequestOptions(RequestMethod.Post, revisedURL, undefined, body, false);
        if (requestOptions != null) {
            return this.http.request(new Request(requestOptions))
                .pipe(map((resp: any) => {
                    this.lastAPICallTime = moment()

                    if (typeof resp._body == 'string' && resp._body.includes('<html')) {
                        this.leaveApplication();
                    }
                    if (url == '/login') {
                        this.token = resp.headers.get('authorization');
                    }
                    if (resp)
                        return this.globalErrorHandler.sanitizeJSONResp(resp)
                    else
                        return resp
                })
                    , catchError(function (error: any) {
                        // if(environment['showAPIConfigError'])
                        // alert("postCallWithAPIMapper URL not working  "+ url)
                        // console.log(url);
                        // // this.APIerrorMap[url] = {
                        // //     revisedURL,error
                        // // }
                        // localStorage.set("APIerrorMap", this.APIerrorMap)
                        if (error.status === 401 || error.status == 403 || error.status === 504) {
                            me.logout()
                        }
                        else if (error.status === 500) {
                            var jsonBody = error._body;
                        }

                        if (me.appMetadataHandler.featureFlags.redirectOnServerErrors) {
                            me.globalErrorHandler.redirectOnServerError(error.status)
                        }
                        //return throwError(error || 'Server error');
                        return of(me.globalErrorHandler.logFailedAPI(error, url))
                    }));
        }
        else {
            this.logout();
            this.leaveApplication();
            var subject = new Subject()
            subject.complete();
            return subject;
        }
    
    }

    postForMultipart(url: string, body: Object): Observable<any> {
        let me = this;
        let requestOptions = this.getRequestOptionsForMultipart(RequestMethod.Post, url, undefined, body);
        return this.http.request(new Request(requestOptions))
            .pipe(map((resp: any) => {
                if (typeof resp._body == 'string' && resp._body.includes('<html')) {
                    this.leaveApplication();
                }
                if (url == '/login') {
                    this.token = resp.headers.get('authorization');
                }
                return resp;
            }),
                catchError(function (error: any) {
                    if (error.status === 401) {
                        me.router.navigate(['/logout']);
                    }
                    else if (error.status === 500) {
                        var jsonBody = error._body;
                    }

                    if (me.appMetadataHandler.featureFlags.redirectOnServerErrors) {
                        me.globalErrorHandler.redirectOnServerError(error.status)
                    }
                    //return throwError(error || 'Server error');
                    return of(me.globalErrorHandler.logFailedAPI(error, url))
                }));
    }

    replacedServiceCdMap ={

    }

    mapperUtil(type, serviceCd, pathVariables?) {
        let url;
        let newServiceCd
     
        // if (this.appMetadataHandler.featureFlags.enableAPIMapper){  
        if (type == 'post') {
            if(serviceCd.includes('/')) {
                newServiceCd = serviceCd.replace(/\/$/, '');
                if (newServiceCd.includes('/')) {
                    let urlWithQueryParams = this.splitMulti(newServiceCd, ['/']);
                    let queryParam = urlWithQueryParams.pop();
                    if (this.isArrayIterable(urlWithQueryParams) && this.isArrayIterable(urlWithQueryParams)) {
                        newServiceCd = urlWithQueryParams + "/"
                        urlWithQueryParams.length > 1 && console.warn(newServiceCd)
                        url = (this.APIEndpointMap[newServiceCd] || this.APIEndpointMap[newServiceCd.slice(0, -1)]) + "/" + queryParam
                    }
                }
            }
            else
              newServiceCd = serviceCd
            if(!url && this.APIEndpointMap[newServiceCd]){
                url = this.APIEndpointMap[newServiceCd]
            }else{
                if(environment['showAPIConfigError']) 
                alert("post URL not present in- "+ serviceCd)
            }
        } else if (type == 'get' && !pathVariables) {
            let urlWithQueryParams = serviceCd
            if (serviceCd.includes('/')) {
                urlWithQueryParams = this.splitMulti(serviceCd, ['/'])
                if (urlWithQueryParams.length <= 2) {
                    let queryParam = urlWithQueryParams.pop()
                    if (this.isArrayIterable(urlWithQueryParams) && this.isArrayIterable(urlWithQueryParams)) {
                        newServiceCd = urlWithQueryParams + "/"
                        urlWithQueryParams.length > 1 && console.warn(newServiceCd)
                        url = (this.APIEndpointMap[newServiceCd] || this.APIEndpointMap[newServiceCd.slice(0, -1)]) + "/" + queryParam
                    }
                }
                else {
                    let newServiceCd = urlWithQueryParams.shift();
                    url = (this.APIEndpointMap[newServiceCd] || this.APIEndpointMap[newServiceCd.slice(0, -1)]);
                    url = this.replaceEndpointArgs(url, urlWithQueryParams);
                }
            } else {
                url = this.APIEndpointMap[urlWithQueryParams]
            }
            
        } else if (pathVariables) {
            url = this.handlePathVariables(pathVariables, serviceCd)
        } else{
            if(environment['showAPIConfigError']) 
            alert("get URL not present in- "+ serviceCd)
        }
        this.replacedServiceCdMap[serviceCd] = url
        localStorage.setItem("replacedServiceCd", JSON.stringify(this.replacedServiceCdMap))
        // }else{
        //     url = serviceCd
        // } 
        // }
        // });
   
        if(url)
        url = url.replaceAll("//", "/")
        return url
        
  
    }

    // mapperUtil(type, serviceCd, pathVariables?) {
    //     let url;
    //     let newServiceCd
    //     // if (this.appMetadataHandler.featureFlags.enableAPIMapper){  
    //     if (type == 'post') {
    //         let newServiceCd = serviceCd.replace(/\/$/, '');
    //         if (this.APIEndpointMap[newServiceCd]) {
    //             url = this.APIEndpointMap[newServiceCd]
    //         } else {
    //             if (environment['showAPIConfigError'])
    //                 alert("post URL not present in- " + serviceCd)
    //         }
    //     } else if (type == 'get' && !pathVariables) {
    //         let urlWithQueryParams = this.splitMulti(serviceCd, ['/'])
    //         let queryParam = urlWithQueryParams.pop()
    //         if (this.isArrayIterable(urlWithQueryParams) && this.isArrayIterable(urlWithQueryParams)) {
    //             newServiceCd = urlWithQueryParams.join("/")
    //             urlWithQueryParams.length > 1 && console.warn(newServiceCd)
    //             url = "/" + this.APIEndpointMap[newServiceCd] + "/" + queryParam
    //         } else {
    //             url = "/" + this.APIEndpointMap[queryParam];
    //         }
    //     } else if (pathVariables) {
    //         url = this.handlePathVariables(pathVariables, serviceCd)
    //     } else {
    //         if (environment['showAPIConfigError'])
    //             alert("get URL not present in- " + serviceCd)
    //     }
    //     this.replacedServiceCdMap[serviceCd] = url
    //     localStorage.setItem("replacedServiceCd", JSON.stringify(this.replacedServiceCdMap))
    //     // }else{
    //     //     url = serviceCd
    //     // }
    //     if (url)
    //         url = url.replaceAll("//", "/")
    //     return url
    // }

    isArrayIterable(data) {
        if (data && Array.isArray(data) && data.length > 0)
            return true
        else
            return false
    }

    handlePathVariables(pathVarables, serviceCd) {
        let urlWithPathRefs = this.APIEndpointMap ? this.APIEndpointMap[serviceCd] : ""
        let urlArray = urlWithPathRefs.split("/")
        let num = 0
        let finalURLArray = this.deepCopy(urlArray)
        let finalURL;
        if (this.isArrayIterable(pathVarables) && this.isArrayIterable(urlArray)) {
            urlArray.forEach((ele, i) => {
                if (ele.includes("$")) {
                    finalURLArray[i] = pathVarables[num]
                    num++
                }
            })
        }

        finalURL = num == 0 ? urlWithPathRefs : finalURLArray.join("/")
        return finalURL
    }

    deepCopy(o) {
        if (o)
            return JSON.parse(JSON.stringify(o));
        else
            return null
    }

    replaceEndpointArgs(url, args) {
        if (typeof url === 'string' && this.isArrayIterable(args)) {
            for (let arg of args) {
                if (typeof arg === 'string') url = url.replace('${}', arg);
            }
        }
        return url;
    }

    put(url: string, body: Object): Observable<any> {
        let me = this;
        let requestOptions = this.getRequestOptions(RequestMethod.Put, url, undefined, body, false);
        if (requestOptions != null) {
            return this.http.request(new Request(requestOptions))
                .pipe(map((resp: any) => {
                    this.lastAPICallTime = moment()
                    if (typeof resp._body == 'string' && resp._body.includes('<html')) {
                        this.leaveApplication();
                    }
                    if (resp)
                        return this.globalErrorHandler.sanitizeJSONResp(resp)
                    else
                        return resp
                })
                    , catchError(function (error: any) {
                        if (error.status === 401) {
                            me.router.navigate(['/logout']);
                        }

                        if (me.appMetadataHandler.featureFlags.redirectOnServerErrors) {
                            me.globalErrorHandler.redirectOnServerError(error.status)
                        }
                        //return throwError(error || 'Server error');
                        return of(me.globalErrorHandler.logFailedAPI(error, url))
                    }));
        }
        else {
            this.logout();
            this.leaveApplication();
            var subject = new Subject()
            subject.complete();
            return subject;
        }
    }

    delete(url: string): Observable<any> {
        let me = this;
        let requestOptions = this.getRequestOptions(RequestMethod.Delete, url, undefined, undefined, false);
        if (requestOptions != null) {
            return this.http.request(new Request(requestOptions))
                .pipe(map((resp: any) => {
                    this.lastAPICallTime = moment()
                    if (typeof resp._body == 'string' && resp._body.includes('<html')) {
                        this.leaveApplication();
                    }
                    if (resp)
                        return this.globalErrorHandler.sanitizeJSONResp(resp)
                    else
                        return resp
                })
                    , catchError(function (error: any) {
                        if (error.status === 401) {
                            me.router.navigate(['/logout']);
                        }

                        if (me.appMetadataHandler.featureFlags.redirectOnServerErrors) {
                            me.globalErrorHandler.redirectOnServerError(error.status)
                        }
                        //return throwError(error || 'Server error');
                        return of(me.globalErrorHandler.logFailedAPI(error, url))
                    }));
        }
        else {
            this.logout();
            this.leaveApplication();
            var subject = new Subject()
            subject.complete();
            return subject;
        }
    }

    logout() {
        let logoutResponce = null
        // this.loaderService.startLoaderWithMessage('Session has expired. Logging out . . .');
        this.logoutAgentCallMethod('user-service/logout')
            .subscribe(jsonResp => {
                logoutResponce = jsonResp;
                localStorage.clear();
                sessionStorage.clear();
                this.userInfoService.removeUserInfo();
                this.router.navigate(['/login']);
                // this.loaderService.stopLoader();
            });

    }

    APIMap = {}
    APIEndpointMap = {}
    APIMasterResponse = []
    getAPIMaster() {
        let APISubject: Subject<any> = new Subject<any>();
        let serviceURL = 'user-service/api/fetchAPIByApplicationCd/NBU'
        if (environment['APIMasterEndpoint']) serviceURL = environment['APIMasterEndpoint']
        this.get(serviceURL)
            .subscribe(jsonResp => {
                this.APIMasterResponse = jsonResp
                if (jsonResp && Array.isArray(jsonResp) && jsonResp.length > 0) {
                    jsonResp.forEach(serviceDO => {
                        this.APIMap[serviceDO.serviceCd] = serviceDO
                        
                        this.APIEndpointMap[serviceDO.serviceCd] = serviceDO.contextURL + '/' + serviceDO.endPointURL
       
                        // this.APIEndpointMap[serviceDO.serviceCd] = serviceDO.endPointURL
                    })
                }
                APISubject.next(jsonResp)
            })

        return APISubject;
    }
    // getAPIMaster() {
    //     let APISubject: Subject<any> = new Subject<any>();
    //     let serviceURL = 'master-service/api/fetchAPIByApplicationCd/NBU'
    //     if (environment['APIMasterEndpoint']) serviceURL = environment['APIMasterEndpoint']
    //     this.get(serviceURL, null, true)
    //         .subscribe(jsonResp => {
    //             this.APIMasterResponse = jsonResp
    //             if (jsonResp && Array.isArray(jsonResp) && jsonResp.length > 0) {
    //                 jsonResp.forEach(serviceDO => {
    //                     this.APIMap[serviceDO.serviceCd] = serviceDO
    //                     this.APIEndpointMap[serviceDO.serviceCd] = serviceDO.contextURL + '/' + serviceDO.endPointURL
    //                 })
    //             }
    //             APISubject.next(jsonResp)
    //         })
    //     return APISubject;
    // }

    authenticate(url: string, body: Object): Observable<any> {

        if (environment.tokenMode) {
            url = 'user-service/login';
        } else {
            url = 'user-service/login';
        }
        let me = this;
        this.lastAPICallTime = moment();
        let requestOptions = this.getRequestOptions(RequestMethod.Post, url, undefined, body);
        return this.http.request(new Request(requestOptions))
            .pipe(map((resp: any) => {
                this.lastAPICallTime = moment()
                if (typeof resp._body == 'string' && resp._body.includes('<html')) {
                    this.leaveApplication();
                }
                if (environment.tokenMode) {
                    this.token = resp.headers.get('authorization');
                }
                if (resp)
                    return this.globalErrorHandler.sanitizeJSONResp(resp)
                else
                    return resp
            }),
                catchError(function (error: any) {

                    if (error.status === 401) {
                        me.router.navigate(['/logout']);
                    }

                    if (me.appMetadataHandler.featureFlags.redirectOnServerErrors) {
                        me.globalErrorHandler.redirectOnServerError(error.status)
                    }

                    if (error.statusText) {
                        me.msg.error(error.statusText);
                        // alert(error.statusText);
                    }
                    //return throwError(error || 'Server error');
                    return of(me.globalErrorHandler.logFailedAPI(error, url))
                }));
    }

    getServiceWithComplexObjectAsQueryString(url: string, param: any): Observable<any> {

        var endpoint = url;
        if (!this.appMetadataHandler.featureFlags.enableAPIMapper)
            url = this.appConfig.baseApiPath + url
        else
            url = this.appConfig.baseApiPath + this.APIEndpointMap[url]
        let params: URLSearchParams = new URLSearchParams();
        for (var key in param) {
            if (param.hasOwnProperty(key)) {
                let val = param[key];
                if (endpoint == 'changePassword' && key == 'userId')
                    params.set(key, val);
                else
                    params.set(key, encodeURIComponent(val));
            }
        }
        this.options = new RequestOptions({ headers: this.httpHeader, params: params });
        return this.http
            .get(url, this.options)
            .pipe(map(this.extractData),
                catchError(this.handleError));
    }

    private extractData(res: Response) {

        let body = res.json();
        return body || {};
    }

    private handleError(error: any) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        return throwError(errMsg);
    }

    logoutAgentCallMethod(url: string, urlParams?: URLSearchParams): Observable<any> {
        let me = this;
        let idleTimeException = true;
        let requestOptions = this.getRequestOptions(RequestMethod.Get, url, urlParams, undefined, idleTimeException);
        return this.http.request(new Request(requestOptions))
            .pipe(map((resp: any) => {
                this.lastAPICallTime = moment()
                if (typeof resp._body == 'string' && resp._body.includes('<html')) {
                    this.leaveApplication();
                }
                if (resp)
                    return this.globalErrorHandler.sanitizeJSONResp(resp)
                else
                    return resp
            }),
                catchError(function (error: any) {
                    if (error.status === 401 || error.status === 403) {
                        me.router.navigate(['/logout']);
                    }

                    if (me.appMetadataHandler.featureFlags.redirectOnServerErrors) {
                        me.globalErrorHandler.redirectOnServerError(error.status)
                    }
                    //return throwError(error || 'Server error');
                    return of(me.globalErrorHandler.logFailedAPI(error, url))
                }));
    }

    msgID
    leaveApplication() {
        if (!this.msgID) {
            this.msgID = this.msg.error("Session has expired. Logging out . . .").messageId;
            this.router.navigate([{ outlets: { modal: null } }]);
            localStorage.clear();
            sessionStorage.clear();
            this.userInfoService.removeUserInfo();
            this.router.navigate(['/login']);
        }
    }

    resetSessionExpiredMsgID() {
        this.msgID = null
    }

    splitMulti(str, tokens = []) {
        let presetTokens = ['/', ' ', '-', '(', ')', ',']
        if (Array.isArray(tokens))
            tokens.push(...presetTokens)
        var tempChar = tokens[0]; // We can use the first token as a temporary join character
        for (var i = 1; i < tokens.length; i++) {
            str = str.split(tokens[i]).join(tempChar);
        }
        str = str.split(tempChar);
        return str;
    }


}
